
import { MANUAL_URL,ADD_MANUAL_SUCCESS,UPDATE_NEW_MANUAL_SUCCESS,DELETE_MANUAL_BYID,ADD_DRAWING_SUCCESS,UPDATE_NEW_DRAWING_SUCCESS,DELETE_DRAWING_BYID, MANUAL_BY_CLIENT, MANUAL_BY_SITEID, MANUAL_DATA_SUCCESS,
   CATEGORY_LIST_SUCCESS,CHANGETYPE_LIST_SUCCESS,MANUAL_CLIENT_DATA_SUCCESS,CATEGORY_DRAWING_DATA_ERROR,CATEGORY_DRAWING_DATA_SUCCESS } from "./actionTypes"
const initialState = {
  newUser: null,
  totalCount: 0,
  drawinglist: [],
}
const getManualURL = (state = initialState, action) => {
  switch (action.type) {
    case MANUAL_URL:
      state = {
        ...state,
        Manualurl: action.payload,
        manualslistError: null,
      }
      break;
    case MANUAL_BY_CLIENT:
      state = {
        ...state,
        Manualbyclients: action.payload,
        manualslistError: null,
      }
      break;
    case MANUAL_CLIENT_DATA_SUCCESS:
      state = {
        ...state,
        Manualbyclient: action.payload,
        manualslistError: null,
      }
      break;    
    case MANUAL_BY_SITEID:
      state = {
        ...state,
        Manualbysites: action.payload,
        manualslistError: null,
      }
      break;
    case MANUAL_DATA_SUCCESS:
      state = {
        ...state,
        Manualbysite: action.payload,
        manualslistError: null,
      }
      break;
    case CATEGORY_LIST_SUCCESS:
      state = {
        ...state,
        categorylist: action.payload,
        categorylistError: null,
      }
      break;
      // case ALL_CATEGORY_DATA:
      //   state = {
      //     ...state,
      //     getcategorylist: action.payload,
      //     categorylistError: null,
      //   }
      //   break;
    case CHANGETYPE_LIST_SUCCESS:
      state = {
        ...state,
        Changetypelist: action.payload,
        ChangetypelistError: null,
      }
      break;
      // case ALL_CHANGETYPE_DATA_SUCCESS:
      //   state = {
      //     ...state,
      //     getChangetypelist: action.payload,
      //     ChangetypelistError: null,
      //   }
      //   break;
    case ADD_MANUAL_SUCCESS:
      state = { ...state, newManual: action.payload }
      break
    case UPDATE_NEW_MANUAL_SUCCESS:
      state = { ...state, updateManual: action.payload }
      break;
    case DELETE_MANUAL_BYID:
      state = {
        ...state, loading: false,
      };
      break;
    case ADD_DRAWING_SUCCESS:
      state = { ...state, newDrawing: action.payload }
      break
    case UPDATE_NEW_DRAWING_SUCCESS:
      state = { ...state, updatedDrawing: action.payload }
      break;
    case DELETE_DRAWING_BYID:
      state = {
        ...state, loading: false,
      };
      break;
    case CATEGORY_DRAWING_DATA_SUCCESS:
      state = {
        ...state,
        drawinglist: action.payload.drawingGetRequest,
        totalCount: action.payload.totalCount,
        drawinglistError: null,
      }
      break;
    case CATEGORY_DRAWING_DATA_ERROR:
      state = { ...state, drawinglisterror: action.payload }
      break;
    default:
      state = { ...state }
      break
  }
  return state
}

export default getManualURL
